<script lang="ts">
  export let id: string;
</script>

<div class="inner-page {id}">
  <slot />
</div>

<style lang="scss">
  .inner-page {
    position: relative;
  }
</style>
